import { Injectable } from "@angular/core";
import { CrmService } from "./crm.service";
import { HttpClient } from "@angular/common/http";
import { Cliente } from "../modelos/Cliente";
@Injectable({
  providedIn: "root",
})
export class PdfService {
  constructor(private crmService: CrmService, private http: HttpClient) {}

  public generarPedidoGDP(
    cliente: Cliente,
    operacion: any,
    tipoEmpresa: string
  ) {
    return this.http
      .post(
        `${this.crmService.urlCRM}/pdfs/generarPDFpedidoGDP/${tipoEmpresa}`,
        {
          cliente,
          operacion,
        },
        { responseType: "text" }
      )
      .toPromise();
  }
}
